/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kTSMroKPFv65RRTb44SCtk

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariants_4Qwqo5IAb22T } from "../user_mentions/PlasmicGlobalVariant__Screen"; // plasmic-import: 4QWQO5iAb22t/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariants_4Qwqo5IAb22T,
});
